/**
 * Pixels publicitaires Meta & TikTok.
 * Activés uniquement si VITE_META_PIXEL_ID / VITE_TIKTOK_PIXEL_ID sont définis.
 * Événements : ViewContent (landing), Lead (clic CTA), CompleteRegistration (compte créé).
 */
const META_ID = (import.meta as any).env?.VITE_META_PIXEL_ID as string | undefined;
const TIKTOK_ID = (import.meta as any).env?.VITE_TIKTOK_PIXEL_ID as string | undefined;

let initialized = false;

function loadMeta(id: string) {
  const w = window as any;
  if (w.fbq) return;
  const n: any = (w.fbq = function (...args: any[]) {
    n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
  });
  if (!w._fbq) w._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const s = document.createElement('script');
  s.async = true;
  s.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(s);
  w.fbq('init', id);
  w.fbq('track', 'PageView');
}

function loadTikTok(id: string) {
  const w = window as any;
  if (w.ttq) return;
  const ttq: any = (w.ttq = []);
  ttq._i = {};
  ttq.methods = ['page', 'track', 'identify', 'instances', 'debug', 'on', 'off', 'once', 'ready', 'alias', 'group', 'enableCookie', 'disableCookie'];
  ttq.setAndDefer = (t: any, e: string) => {
    t[e] = (...a: any[]) => t.push([e, ...a]);
  };
  ttq.methods.forEach((m: string) => ttq.setAndDefer(ttq, m));
  ttq.load = (pixelId: string) => {
    ttq._i[pixelId] = [];
    const s = document.createElement('script');
    s.async = true;
    s.src = `https://analytics.tiktok.com/i18n/pixel/events.js?sdkid=${pixelId}&lib=ttq`;
    document.head.appendChild(s);
  };
  ttq.load(id);
  ttq.page();
}

export const adPixels = {
  init() {
    if (initialized || typeof window === 'undefined') return;
    initialized = true;
    try {
      if (META_ID) loadMeta(META_ID);
      if (TIKTOK_ID) loadTikTok(TIKTOK_ID);
    } catch {
      /* le tracking ne doit jamais casser le site */
    }
  },

  /** event : ViewContent | Lead | CompleteRegistration */
  track(event: 'ViewContent' | 'Lead' | 'CompleteRegistration', params?: Record<string, any>) {
    adPixels.init(); // les effets enfants s'exécutent avant l'init du parent
    try {
      const w = window as any;
      if (META_ID && w.fbq) w.fbq('track', event, params);
      if (TIKTOK_ID && w.ttq) w.ttq.track(event, params);
    } catch {
      /* ignore */
    }
  },
};
